module.exports = __webpack_public_path__ + "assets/img/banner@2x.ce041292.png";